var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _g, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    viewBox: "0 0 91 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 92,
    rx: 2,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 54,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5512 29.1855L42.9688 70.768L49.8734 77.045L90.999 35.9194L88.7705 33.5084L84.5512 29.1855Z",
    fill: "#E62645"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10359:22201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 29,
    width: 49,
    height: 49
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5512 29.1855L42.9688 70.768L49.8734 77.045L90.999 35.9194L88.7705 33.5084L84.5512 29.1855Z",
    fill: "#E62645"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10359:22201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2035 34.7139L49.8733 77.044L46.1072 73.9056L88.1676 31.8438L89.593 32.3029L92.2035 34.7139Z",
    fill: "#A7163E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9695 70.7681L37.3203 83.3219L49.8742 77.045L42.9695 70.7681Z",
    fill: "#D7AE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3203 83.3203L42.7605 80.6005L39.8524 77.6924L37.3203 83.3203Z",
    fill: "#4B4A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.795252db2bb2c4bf9b7f2a592e360aaf.svg";
export { ForwardRef as ReactComponent };